import '@cds/core/button/register.js';
import '@cds/core/icon/register.js';
import { ClarityIcons, userIcon, homeIcon, keyIcon, exclamationCircleIcon, checkCircleIcon, windowCloseIcon, cloudIcon, lockIcon } from '@cds/core/icon';
ClarityIcons.addIcons(userIcon, homeIcon, keyIcon, exclamationCircleIcon, checkCircleIcon, windowCloseIcon, cloudIcon, lockIcon);

// import '@clr/ui/clr-ui.min.css';
// import '@cds/core/global.min.css';
// import '@cds/core/styles/theme.dark.min.css';
// import '@cds/city/css/bundles/default.min.css';
